import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("Recovered from a render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen clean-bg flex items-center justify-center p-6 text-center">
          <div className="glass-panel rounded-2xl p-10 max-w-md">
            <h2 className="text-xl font-bold text-white mb-2">Something hiccuped</h2>
            <p className="text-sm text-zinc-400 mb-6">We hit a small snag rendering this view. Reloading usually fixes it.</p>
            <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }} className="px-6 py-3 bg-primary-600 text-white rounded-xl font-bold hover:bg-primary-500 transition-colors">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
